import { IconButton, makeStyles, SvgIcon } from '@material-ui/core';
import React from 'react';
import { AddCircleIcon } from './SvgIcons';

export interface IPlusButton {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  open: boolean;
  disabled?: boolean;
}

const useStyles = makeStyles(theme => ({
  button: {
    color: theme.palette.primary.main,
    height: '24px',
    width: '24px',
  },
}));

const PlusButton: React.FC<IPlusButton> = ({
  onClick,
  open,
  disabled = false,
}) => {
  const { button } = useStyles();

  return (
    <IconButton
      className={button}
      onClick={onClick}
      disabled={disabled}
      style={{
        transform: open ? 'rotate(45deg)' : 'rotate(0deg)',
      }}
    >
      <SvgIcon color="inherit" style={{ fontSize: '28px' }}>
        {AddCircleIcon}
      </SvgIcon>
    </IconButton>
  );
};

export default PlusButton;
